import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi, X } from 'lucide-react';

export const OfflineIndicator: React.FC = () => {
    const [isOffline, setIsOffline] = useState(!navigator.onLine);
    const [isVisible, setIsVisible] = useState(false);
    const [justReconnected, setJustReconnected] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOffline(false);
            setJustReconnected(true);

            // Mostrar mensagem de "Voltou" por alguns segundos
            setTimeout(() => {
                setJustReconnected(false);
                setIsVisible(false);
            }, 3000);
        };

        const handleOffline = () => {
            setIsOffline(true);
            setIsVisible(true);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Check inicial
        if (!navigator.onLine) {
            setIsVisible(true);
        }

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (!isVisible && !justReconnected) return null;

    return (
        <div className={`fixed bottom-0 left-0 right-0 z-[100] transition-transform duration-300 ease-in-out transform ${isVisible || justReconnected ? 'translate-y-0' : 'translate-y-full'}`}>
            <div className={`w-full p-2 flex items-center justify-center gap-2 text-sm font-medium text-white shadow-lg ${isOffline ? 'bg-red-500/95' : 'bg-emerald-500/95'} backdrop-blur-sm`}>
                {isOffline ? (
                    <>
                        <WifiOff size={16} />
                        <span>Você está offline. Verifique sua conexão.</span>
                    </>
                ) : (
                    <>
                        <Wifi size={16} />
                        <span>Conexão restabelecida!</span>
                        <button
                            onClick={() => setIsVisible(false)}
                            className="absolute right-4 p-1 hover:bg-white/20 rounded-full"
                        >
                            <X size={14} />
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};
